export const StepIndicator = ({ steps, currentStep = 0, onChangeStep }) => {
  return (
    <div className="d-flex align-items-center">
      {steps.map((step, index) => (
        <div
          key={step}
          className={`d-flex align-items-center ${index < steps.length - 1 ? "flex-grow-1" : ""
            }`}
          onClick={()=>onChangeStep(index)}
        >
          {/* Step */}
          <div className="d-flex align-items-center gap-2 c-pointer">
            <div
              className={`d-flex align-items-center justify-content-center rounded-circle border border-2 fw-semibold small ${index <= currentStep
                  ? "bg-accent border-light text-white"
                  : "bg-white border-secondary-subtle text-secondary"
                }`}
              style={{
                height: "40px",
                width: "40px",
                minWidth: "40px",
                transition: "all 0.2s",
              }}
            >
              {index + 1}
            </div>

            <span
              className={`small ${index <= currentStep
                  ? "text-dark fw-medium"
                  : "text-secondary"
                }`}
            >
              {step}
            </span>
          </div>

          {/* Line */}
          {index < steps.length - 1 && (
            <div
              className={`mx-3 rounded-pill flex-grow-1 ${index < currentStep ? "bg-accent" : "bg-secondary-subtle"}`}
              style={{
                height: "4px",
                minWidth: "20px",
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}